// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  background: #f5f5f5;
}

.app {
  min-height: 100vh;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #000;
}

.login-container h1 {
  color: white;
  margin-bottom: 30px;
  font-weight: 300;
  letter-spacing: -1px;
}

.login-container form {
  background: white;
  padding: 40px;
  border: 1px solid #000;
  min-width: 400px;
}

.login-container input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 0.95rem;
  margin-bottom: 15px;
}

.login-container button {
  width: 100%;
  padding: 14px;
  background: #000;
  color: white;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 0.95rem;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.login-container button:hover {
  background: #333;
}

.error {
  color: #f44336;
  padding: 12px;
  background: #ffebee;
  border: 1px solid #f44336;
  margin-bottom: 15px;
  font-size: 0.9rem;
}

.header {
  background: #000;
  color: white;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  font-weight: 300;
  letter-spacing: -1px;
}

.header div {
  display: flex;
  gap: 15px;
}

.btn-create {
  padding: 10px 24px;
  background: white;
  color: #000;
  border: 1px solid white;
  border-radius: 2px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.btn-create:hover {
  background: #f5f5f5;
}

.btn-logout {
  padding: 10px 24px;
  background: transparent;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.btn-logout:hover {
  border-color: white;
}

.container {
  max-width: 1400px;
  margin: 40px auto;
  padding: 0 40px;
}

.users-table {
  width: 100%;
  background: white;
  border-collapse: collapse;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.users-table th {
  background: #f5f5f5;
  padding: 15px;
  text-align: left;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #000;
}

.users-table td {
  padding: 15px;
  border-bottom: 1px solid #eee;
  font-size: 0.9rem;
}

.users-table tr:hover {
  background: #fafafa;
}

.btn-edit, .btn-delete {
  padding: 8px;
  border: 1px solid #000;
  border-radius: 2px;
  cursor: pointer;
  margin-right: 8px;
  background: white;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-edit:hover {
  background: #000;
  color: white;
}

.btn-delete {
  border-color: #f44336;
  color: #f44336;
}

.btn-delete:hover {
  background: #f44336;
  color: white;
}

.btn-report-count {
  padding: 8px 16px;
  border: 1px solid #000;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  transition: all 0.2s ease;
  font-weight: 600;
  font-size: 0.95rem;
}

.btn-report-count:hover {
  background: #000;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  padding: 40px;
  border: 1px solid #000;
  width: 900px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.modal-section h3 {
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 20px;
  color: #000;
  letter-spacing: -0.3px;
}

.modal-section label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 15px;
}

.modal-section label > span {
  font-size: 0.85rem;
  font-weight: 500;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.modal-section select {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 0.95rem;
  background: white;
}

.modal h2 {
  font-size: 1.8rem;
  font-weight: 300;
  margin-bottom: 30px;
  color: #000;
  letter-spacing: -0.5px;
}

.modal input {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 0.95rem;
}

.modal input:focus {
  outline: none;
  box-shadow: inset 0 0 0 1px #000;
}

.modal-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

.btn-cancel, .btn-submit {
  flex: 1 1;
  padding: 14px 24px;
  border: 1px solid #000;
  border-radius: 0;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.btn-cancel {
  background: #fff;
  color: #000;
}

.btn-cancel:hover {
  background: #f5f5f5;
}

.btn-submit {
  background: #000;
  color: #fff;
}

.btn-submit:hover {
  background: #333;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8JAA8J;EAC9J,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  background: #f5f5f5;\n}\n\n.app {\n  min-height: 100vh;\n}\n\n.login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #000;\n}\n\n.login-container h1 {\n  color: white;\n  margin-bottom: 30px;\n  font-weight: 300;\n  letter-spacing: -1px;\n}\n\n.login-container form {\n  background: white;\n  padding: 40px;\n  border: 1px solid #000;\n  min-width: 400px;\n}\n\n.login-container input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #000;\n  border-radius: 0;\n  font-size: 0.95rem;\n  margin-bottom: 15px;\n}\n\n.login-container button {\n  width: 100%;\n  padding: 14px;\n  background: #000;\n  color: white;\n  border: 1px solid #000;\n  border-radius: 0;\n  font-size: 0.95rem;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.login-container button:hover {\n  background: #333;\n}\n\n.error {\n  color: #f44336;\n  padding: 12px;\n  background: #ffebee;\n  border: 1px solid #f44336;\n  margin-bottom: 15px;\n  font-size: 0.9rem;\n}\n\n.header {\n  background: #000;\n  color: white;\n  padding: 20px 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h1 {\n  font-weight: 300;\n  letter-spacing: -1px;\n}\n\n.header div {\n  display: flex;\n  gap: 15px;\n}\n\n.btn-create {\n  padding: 10px 24px;\n  background: white;\n  color: #000;\n  border: 1px solid white;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n}\n\n.btn-create:hover {\n  background: #f5f5f5;\n}\n\n.btn-logout {\n  padding: 10px 24px;\n  background: transparent;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n}\n\n.btn-logout:hover {\n  border-color: white;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 40px auto;\n  padding: 0 40px;\n}\n\n.users-table {\n  width: 100%;\n  background: white;\n  border-collapse: collapse;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.users-table th {\n  background: #f5f5f5;\n  padding: 15px;\n  text-align: left;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #000;\n}\n\n.users-table td {\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n  font-size: 0.9rem;\n}\n\n.users-table tr:hover {\n  background: #fafafa;\n}\n\n.btn-edit, .btn-delete {\n  padding: 8px;\n  border: 1px solid #000;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-right: 8px;\n  background: white;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn-edit:hover {\n  background: #000;\n  color: white;\n}\n\n.btn-delete {\n  border-color: #f44336;\n  color: #f44336;\n}\n\n.btn-delete:hover {\n  background: #f44336;\n  color: white;\n}\n\n.btn-report-count {\n  padding: 8px 16px;\n  border: 1px solid #000;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  transition: all 0.2s ease;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.btn-report-count:hover {\n  background: #000;\n  color: white;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  padding: 40px;\n  border: 1px solid #000;\n  width: 900px;\n  max-width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n}\n\n.modal-section h3 {\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-bottom: 20px;\n  color: #000;\n  letter-spacing: -0.3px;\n}\n\n.modal-section label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 15px;\n}\n\n.modal-section label > span {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.modal-section select {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #000;\n  border-radius: 0;\n  font-size: 0.95rem;\n  background: white;\n}\n\n.modal h2 {\n  font-size: 1.8rem;\n  font-weight: 300;\n  margin-bottom: 30px;\n  color: #000;\n  letter-spacing: -0.5px;\n}\n\n.modal input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #000;\n  border-radius: 0;\n  font-size: 0.95rem;\n}\n\n.modal input:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 1px #000;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.btn-cancel, .btn-submit {\n  flex: 1;\n  padding: 14px 24px;\n  border: 1px solid #000;\n  border-radius: 0;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.btn-cancel {\n  background: #fff;\n  color: #000;\n}\n\n.btn-cancel:hover {\n  background: #f5f5f5;\n}\n\n.btn-submit {\n  background: #000;\n  color: #fff;\n}\n\n.btn-submit:hover {\n  background: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
